import { useEffect, useState } from 'react';

import IconButton from './Buttons/IconButton';
import { Loader } from './Loader';

import { Previous } from '../../icons';
import { Next } from '../../icons';

export const Carousel = ({ thumbnails }) => {
    const [activeImage, setActiveImage] = useState(0);
    const image = thumbnails?.[activeImage];
    const url = image?.url;

    useEffect(() => {
        setActiveImage(0);
    }, [thumbnails]);

    if (!thumbnails)
        return (
            <div className="flex h-full w-full justify-center items-center">
                <Loader />
            </div>
        );

    return (
        <div style={{ backgroundColor: 'white', width: '100%', height: '100%' }}>
            <div style={{ height: 70, padding: '16px 8px', borderBottom: '1px solid rgb(229, 231, 235)' }}>
                <h1 style={{ fontSize: 18, fontWeight: 600 }}>Catalog Images</h1>
            </div>
            {thumbnails.length ? (
                <div style={{ padding: '16px 20px', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    <div style={{ borderRadius: 8, width: 540, height: 460, backgroundColor: '#FFFFFF' }}>
                        <img style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 8 }} src={url} alt="" />
                    </div>

                    <div className=" flex flex-row m-auto w-full gap-2 mt-4 mr-4 content-center justify-end">
                        <button disabled={activeImage === 0} onClick={() => setActiveImage(activeImage - 1)} style={{ backgroundColor: '#D1D1D1', width: 40, height: 40, borderRadius: '50%' }}>
                            <Previous />
                        </button>
                        <button disabled={activeImage === thumbnails.length - 1} onClick={() => setActiveImage(activeImage + 1)} style={{ backgroundColor: '#D1D1D1', width: 40, height: 40, borderRadius: '50%' }}>
                            <Next />
                        </button>
                    </div>

                    <div className="flex flex-row gap-8 mt-4 mr-4 flex-wrap">
                        {thumbnails.map((src, i) => {
                            return (
                                <div style={{ width: 54, height: 54, border: `4px solid ${activeImage === i ? '#F9C11B' : 'white'}`, borderRadius: 8 }}>
                                    <img src={src.url} onClick={() => setActiveImage(i)} style={{ width: '100%', height: '100%', objectFit: 'cover', cursor: 'pointer' }} alt="" />
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <div className="flex h-full w-full justify-center items-center">
                    <p>Sorry! We dont have any images available for this product.</p>
                </div>
            )}
        </div>
    );
};
